import React, { useEffect, useState,useContext,useRef } from 'react';
import AppContext from "../AppContext"
import { Row,Divider,Col,Space,Modal,Form,Select,Input,Upload,Button,Collapse,message,Typography,List, Popconfirm, Table } from 'antd';
import { GetTranslation } from '../../Models/shared/general';
import {
    onLoadPayee,
    onUpdatePayee
} from '../../Controller/Management/PaymentManagement'

import IconButton from '@mui/material/IconButton';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';

import TextField from '@mui/material/TextField';

import Autocomplete from '@mui/material/Autocomplete';
import { DownloadOutlined,SearchOutlined,CheckOutlined,CloseOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import Backdrop from '@mui/material/Backdrop';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';

export default function PayeeManagement(prop) {


    const userlang                                              = navigator.language || navigator.userLanguage;

    const [Mpayee, setMpayee]                                   = useState();
    const [Mbank, setMbank]                                     = useState();
    const [Mtype, setMtype]                                     = useState();
    const [Mcurrency, setMcurrency]                             = useState();
    
    const [ModalEditVisible, setModalEditVisible]               = useState(false)
    const [CreateForm,setCreateForm]                            = useState(false)
    const [Pobjid, setPobjid]                                   = useState('')
    const [Ppayeeid, setPpayeeid]                               = useState('')
    const [Pdesc, setPdesc]                                     = useState('')
    const [Pbank, setPbank]                                     = useState('')
    const [Pbankacct, setPbankacct]                             = useState('')
    const [Pcurrency, setPcurrency]                             = useState('')
    const [Ppaymentcode, setPpaymentcode]                       = useState('')
    const [Ptype, setPtype]                                     = useState('')

    const [opendialog,setopendialog]                            = useState(false)
    const [dialogtitle,setdialogtitle]                          = useState("")
    const [dialogstatus,setdialogstatus]                        = useState("")

    const [ProgressStatus, setPogressStatus]                    = useState(false);

    const [search, setSearch] = useState({ Text: "", Column: "" })


    const getColumnSearchProps = (dataIndex, title) => ({

        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>

                <Input
                   
                    autoFocus={true}
                    placeholder={`Search ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => {
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                        //handleSearch(e.target.value, confirm, dataIndex)
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            //setSelectedKeys(e.target.value ? [e.target.value] : [])
                            handleSearch(e.target.value, confirm, dataIndex)
                        }
                    }}
                    style={{ width: 200, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        data-reset='reset'
                        type="link"
                        onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? "crimson" : undefined }} />,

        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',

        render: (text) =>
            search.Column === dataIndex ?
                (
                    <Highlighter
                        highlightStyle={{ backgroundColor: "gold", padding: 0 }}
                        searchWords={[search.Text]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                )
                : (
                    text
                ),


    });
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm({ closeDropdown: false });
        setSearch({
            Text: selectedKeys,
            Column: dataIndex,
        });
     
    };
    const handleReset = clearFilters => {
        clearFilters({ closeDropdown: false });
        setSearch({ Column: search.Column, Text: '' });
    };

    function Ptypechange(e,type,e2)
    {
      if(e != null)
      {

        if(type == 1)
        {
            setPtype(e.value)
          
        }
        else if(type ==2)
        {
          
            setPtype(e.toUpperCase())
         
        }
        

      }
    }

    function Pbankchange(e,type,e2)
    {
      if(e != null)
      {

        if(type == 1)
        {
            setPbank(e.value)
          
        }
        else if(type ==2)
        {
          
            setPbank(e.toUpperCase())
         
        }
        

      }
    }
    function Pcurrencychange(e,type,e2)
    {
      if(e != null)
      {

        if(type == 1)
        {
            setPcurrency(e.value)
          
        }
        else if(type ==2)
        {
          
            setPcurrency(e.toUpperCase())
         
        }
        

      }
    }

    function handleSnackClose()
    {
        setopendialog(false)
       
    }
    async function LoadPayeeListing()
    {
        var result = await onLoadPayee("")

        // var newlist = []
        // var obj     = {}

        
        // result.data.forEach((items) =>{
        //     obj = {}

        //     // obj["label"]            = items.description ? items.payeeid + " - " + items.description : items.payeeid
        //     // obj["value"]            = items.payeeid
        //     obj["bank"]             = items.bank
        //     obj["bankacct"]         = items.bankacct
        //     obj["currency"]         = items.currency
        //     obj["payeeid"]          = items.payeeid
        //     obj["type"]             = items.type
        //     obj["description"]      = items.description ? items.description : ""

        //     newlist.push(obj)
        // })

        const groupedBANK = result.data.reduce((groups, item) => {
            const { bank } = item;
            const key = `${bank}`;
            if (!groups[key]) {
              groups[key] = { text :bank,value :bank ,label :bank };
            } else {
            }
            return groups;
          }, {});

         let tempbank = Object.values(groupedBANK)
         tempbank = tempbank.filter((x) => x.value != undefined)
        tempbank = tempbank.sort((a,b)=> (a.value.toString().localeCompare(b.value.toString())))

        setMbank(tempbank)
       

         const groupedTYPE = result.data.reduce((groups, item) => {
            const { type } = item;
            const key = `${type}`;
            if (!groups[key]) {
              groups[key] = { text :type,value :type  ,label : type};
            } else {
            }
            return groups;
          }, {});

         let temptype = Object.values(groupedTYPE)
         temptype = temptype.filter((x) => x.value != undefined)
         temptype = temptype.sort((a,b)=> (a.value.toString().localeCompare(b.value.toString())))

        setMtype(temptype)
         

         const groupedCURR = result.data.reduce((groups, item) => {
            const { currency } = item;
            const key = `${currency}`;
            if (!groups[key]) {
              groups[key] = { text :currency,value :currency,label:currency };
            } else {
            }
            return groups;
          }, {});

         let tempcurrency = Object.values(groupedCURR)
         tempcurrency = tempcurrency.filter((x) => x.value != undefined)
         tempcurrency = tempcurrency.sort((a,b)=> (a.value.toString().localeCompare(b.value.toString())))

        setMcurrency(tempcurrency)
       
        setMpayee(result.data)
        
    }
    async function UpdatePayeeStatus(data)
    {
        let tempmpayee = Mpayee

        setPogressStatus(true)
        let data1 = {
            _id         : data._id,
            active      : !data.active
        }

      
        var result1 = await onUpdatePayee(data1)
       
        if(result1.status == 'ok')
        {
            
            setdialogtitle("Update Successfully!")
            setdialogstatus("success")
            setopendialog(true)
        }
        else
        {
            setdialogtitle("Update fail, please contact IT!")
            setdialogstatus("error")
            setopendialog(true)
        }
        tempmpayee = tempmpayee.map(x => x._id === data._id ? ({...x, active: !data.active} ) : (x))

        setPogressStatus(false)
        setMpayee(tempmpayee)
       
    }
    function handleModalOpen(data,type)
    {
        if(type == 1)
        {
            setCreateForm(true)
            setPobjid(data._id)
            setPpayeeid(data.payeeid)
            setPdesc(data.description)
            setPbank(data.bank)
            setPbankacct(data.bankacct)
            setPcurrency(data.currency)
            setPpaymentcode(data.paymentcode)
            setPtype(data.type)
        }
        else if(type == 2)
        {
            setCreateForm(false)
            setPobjid('')
            setPpayeeid('')
            setPdesc('')
            setPbank('')
            setPbankacct('')
            setPcurrency('')
            setPpaymentcode('')
            setPtype('')
        }
      
        
        setModalEditVisible(true)
    }
    function handleModalClose(data)
    {
        setCreateForm(false)
        setPobjid('')
        setPpayeeid('')
        setPdesc('')
        setPbank('')
        setPbankacct('')
        setPcurrency('')
        setPpaymentcode('')
        setPtype('')

        setModalEditVisible(false)
    }
    async function handleModalSave()
    {
        if(Ppayeeid == undefined || Ppayeeid == null || Ppayeeid == '')
        {
            message.error("Please Key In Payee ID !!")
            return
        }
        if(Pbank == undefined || Pbank == null || Pbank == '')
        {
            message.error("Please Select Bank !!")
            return
        }
        if(Pbankacct == undefined || Pbankacct == null || Pbankacct == '')
        {
            message.error("Please Key In Bank Acct !!")
            return
        }
        if(Pcurrency == undefined || Pcurrency == null || Pcurrency == '')
        {
            message.error("Please Select Currency !!")
            return
        }
        if(Ptype == undefined || Ptype == null || Ptype == '')
        {
            message.error("Please Select Payee Type !!")
            return
        }

        let data1 = {
            _id         : Pobjid,
            payeeid     : Ppayeeid,
            description : Pdesc,
            bank        : Pbank,
            bankacct    : Pbankacct,
            currency    : Pcurrency,
            paymentcode : Ppaymentcode,
            type        : Ptype
        }

        if(CreateForm == false)
        {
           
            data1.active = 1
        }
        setPogressStatus(true)
      
        var result1 = await onUpdatePayee(data1)

        if(result1.status == 'ok')
        {
            
            setdialogtitle("Update Successfully!")
            setdialogstatus("success")
            LoadPayeeListing()
            setopendialog(true)
            setModalEditVisible(false)
        }
        else
        {
            setdialogtitle("Update fail, please contact IT!")
            setdialogstatus("error")
            setopendialog(true)
        }
        setPogressStatus(false)
        console.log("save")
    }
    var payeecolumn = 
    [
        {
            title: <div>Payee</div>,
            dataIndex: 'payeeid',
            fixed: 'left',
            ...getColumnSearchProps('payeeid','Payee'),
        },  
        {
            title: <div>Description</div>,
            dataIndex: 'description',
            ...getColumnSearchProps('description','Description'),
        },  
        {
            title: <div>Type</div>,
            dataIndex: 'type',
            filters:Mtype,
            onFilter: (value, record) => record.type.indexOf(value) === 0,
            
        },  
       
        {
            title: <div>Bank</div>,
            dataIndex: 'bank',
            filters:Mbank,
            onFilter: (value, record) => record.bank.indexOf(value) === 0,
            
        },  
        {
            title: <div>Bankacct</div>,
            dataIndex: 'bankacct',
            ...getColumnSearchProps('bankacct','Bankacct'),
        },  
        {
            title: <div>Currency</div>,
            dataIndex: 'currency',
            filters:Mcurrency,
            onFilter: (value, record) => record.currency.indexOf(value) === 0,
            
        },  
        {
            title: <div>Paymentcode</div>,
            dataIndex: 'paymentcode',
            ...getColumnSearchProps('paymentcode','Paymentcode'),
        },  
        {
          title: '',
          dataIndex: 'operation',
          width: '10%',
          render: (_, record) =>
            <>
                <IconButton onClick={() => handleModalOpen(record,1)}>
                <EditIcon style={{color:"seagreen",fontSize:"xx-large"}}></EditIcon>
                </IconButton>
            {
                record.active == 1 ?
                <>
                <IconButton onClick={() => UpdatePayeeStatus(record)}>
                <ToggleOffIcon style={{color:"seagreen",fontSize:"xx-large"}}></ToggleOffIcon>
                </IconButton>
                </>
                :
                <>
                <IconButton onClick={() => UpdatePayeeStatus(record)}>
                <ToggleOnIcon style={{color:"red",fontSize:"xx-large"}}></ToggleOnIcon>
                </IconButton>
                </>
            }
          
            </>
        },
    ]

    useEffect(() => {
      
       
        LoadPayeeListing()
    
    },[])

    return (
        <>
         <Row justify="start">
            <div style={{width:"80%"}}>
            <Divider style={{paddingLeft:"10%"}}>{GetTranslation(userlang,prop.title) ?? "." }</Divider>
             </div>
             <div style={{width:"20%",display:"flex",alignItems:"center"}}>
                 <IconButton onClick={(val) => handleModalOpen('',2)}>
                 <AddCircleOutlineIcon style={{color:"blue"}}> 

                    </AddCircleOutlineIcon>
                 </IconButton>
                 
             </div>
           
        </Row>
        <Row>
            <div style={{width:"100%"}}>
            <Table
            bordered
            dataSource={Mpayee}
            columns={payeecolumn}
            size="small"
            pagination={false}
            >
                </Table>
            </div>
            
        </Row>
       <Modal
       visible={ModalEditVisible}
       title={"Edit"}
       onCancel={(val) =>handleModalClose()}
       footer={[
        <Button key="back" onClick={(val) =>handleModalClose()}>
          Return
        </Button>,
        <Button key="submit" type="primary" onClick={(val) => handleModalSave()}>
          Save
        </Button>,
       ]}
       >
        <Row>
            <div style={{width:"100%"}}>

           
            <div >
                <TextField
                style={{width:"100%"}}
                disabled={CreateForm}
                label="Payee ID"
                value={Ppayeeid}
                onChange={(val1) => setPpayeeid(val1.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
            <br/>
            <div >
                <TextField
                style={{width:"100%"}}
                label="Description"
                value={Pdesc}
                multiline={true}
                onChange={(val1) => setPdesc(val1.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
            <br/>
            <div>
            <Autocomplete
            freeSolo
            value={Ptype}
            onChange={(val1,val2) => Ptypechange(val2,1)}
            onInputChange={(val1,val2) => Ptypechange(val2,2)}
            inputValue={Ptype}
            options={Mtype}
            isOptionEqualToValue={(option, value) => option.value === value}
            renderInput={(params) => <TextField {...params} label="Type" />}>
            </Autocomplete>
            </div>
            <br/>
            <div>
            <Autocomplete
            freeSolo
            value={Pbank}
            onChange={(val1,val2) => Pbankchange(val2,1)}
            onInputChange={(val1,val2) => Pbankchange(val2,2)}
            inputValue={Pbank}
            options={Mbank}
            isOptionEqualToValue={(option, value) => option.value === value}
            renderInput={(params) => <TextField {...params} label="Bank" />}>
            </Autocomplete>
            </div>
            <br/>
            <div >
                <TextField
                style={{width:"100%"}}
                label="Bankacct"
                value={Pbankacct}
                onChange={(val1) => setPbankacct(val1.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
            <br/>
            <div>
            <Autocomplete
            freeSolo
            value={Pcurrency}
            onChange={(val1,val2) => Pcurrencychange(val2,1)}
            onInputChange={(val1,val2) => Pcurrencychange(val2,2)}
            inputValue={Pcurrency}
            options={Mcurrency}
            isOptionEqualToValue={(option, value) => option.value === value}
            renderInput={(params) => <TextField {...params} label="Bank" />}>
            </Autocomplete>
            </div>
            <br/>
            <div >
                <TextField
                style={{width:"100%"}}
                label="Paymentcode"
                multiline={true}
                value={Ppaymentcode}
                onChange={(val1) => setPpaymentcode(val1.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
            </div>
        </Row>

       </Modal>
       <Snackbar 
      anchorOrigin={{ vertical: "top", horizontal: "center" }} 
      open={opendialog} 
      autoHideDuration={6000} 
      onClose={handleSnackClose}>
        <Alert onClose={handleSnackClose} variant="filled" severity={dialogstatus}  sx={{ width: '100%' }}>
          {dialogtitle}
        </Alert>
      </Snackbar>
       <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={ProgressStatus}>
     
      <CircularProgress color="inherit" />
      </Backdrop>
        </>
    )

}